import type { IANATimezones } from '@gcv/shared';
import { DateTime } from 'luxon';

import { DefaultIANATimezone } from 'util/dateTime.util';

export const DEFAULT_ASSESSMENT_RESPONSE_DAYS = 30;

export const getDefaultAssessmentDueDate = (timeToRespondDays?: number, timezone?: IANATimezones): string => {
  const days =
    timeToRespondDays === undefined || timeToRespondDays === null || timeToRespondDays < 0
      ? DEFAULT_ASSESSMENT_RESPONSE_DAYS
      : timeToRespondDays;

  const today = DateTime.now()
    .setZone(timezone ?? DefaultIANATimezone)
    .startOf('day');
  const dueDate = today.plus({ days });

  // Never default to a date the picker would reject.
  return (dueDate < today ? today : dueDate).toUTC().toISO() as string;
};
